// extracted by mini-css-extract-plugin
export var footer = "_ol-5";
export var fulfillmentInput = "_ol-0";
export var shipDateInput = "_ol-1";
export var shipmentModal = "_ol-2";
export var shipmentModalContent = "_ol-3";
export var tableContainer = "_ol-4";